<template xmlns="http://www.w3.org/1999/html">
	<v-container>
			<div class="base-page">
				<logo-with-title :title="$t('forgotPasswordPage.resetPassword')" />
				<template v-if="msg">
					<v-row>
						<v-col class="bordered">
							<h4 class="text-center primary--text">{{ msg }}</h4>
						</v-col>
					</v-row>
				</template>
				<template v-else>
					<v-row>
						<v-col>
							<v-form ref="form" method="POST" action="/forgot-password">
								<input type="hidden" name="_token" :value="csrf" />
								<v-card-text>
									<smart-input
										v-model="form.email"
										class="base-input"
										:required="true"
										name="email"
										:label="$t('email')"
										:errors="errors.email"
										type="email"
									/>
								</v-card-text>
								<v-card-actions class="d-flex flex-column mt-8">
									<v-row>
										<v-col>
											<v-btn type="submit" block color="btnColor" rounded >
												{{ $t('forgotPasswordPage.getEmail') }}
											</v-btn>
										</v-col>
									</v-row>
								</v-card-actions>
							</v-form>
							<lang-select />
						</v-col>
					</v-row>
				</template>
			</div>
	</v-container>
</template>

<script>
import LangSelect from "../../components/LangSelect.vue";
import LogoWithTitle from "@/components/LogoWithTitle";
export default {
	name: "ForgotPassword",
	components: { LogoWithTitle, LangSelect },
	props: {
		admin: {
			type: Boolean
		}
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: ""
		},
		errors: {}
	}),
	computed: {
		csrf() {
			return document
				.querySelector("meta[name=csrf-token]")
				.getAttribute("content");
		},
		msg() {
			return window.resetMessage;
		}
	},
	methods: {
		gotoRegister() {
			this.$router.push({ path: "/register" });
		}
	}
};
</script>

<style lang="scss" scoped>

.page {

	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}

</style>
